export default function Education({ education, index }){

    const { school, title, description, startDate, endDate} = education

    return(
        <div 
            data-aos="fade-left"
            data-aos-anchor=".aos-istruzione"
            data-aos-delay={`${index * 100 + 200}`}
        >

            <div className="row align-items-center d-none d-md-flex"
            >
                <div className="col-1 dot">
                    <i className="fas fa-circle fa-xs"></i>
                </div>
                <div className="col">
                    <h5>{school}<span>{startDate} - {endDate}</span></h5>
                </div>
            </div>
            
            {/* SOLO MOBILE */}

            <div className="row align-items-center d-md-none ms-0">
                <div className="col-1 dot">
                </div>
            <div className="col date-mobile ps-0">
                <h5>{school}</h5>
                <p className="m-0 font-weight-bold">{startDate} - {endDate}</p>
            </div>
            </div>
            
            <div className="row align-items-center mt-1 ms-0">
                <div className="col-1 dot"> 
                </div>
                <div className="col ps-1">
                    <p><strong>{title}</strong> - {description}</p>
                </div>
            </div>

        </div>
    )
}